import { Box } from '@primer/react';
import React, { useMemo } from 'react';
interface IUserAvatarProps {
    url?: string,
    fullName?: string,
    size?: "small" | "medium" | "large" | "xlarge" | "xxlarge" | "xxxlarge",
    borderRadius?: string
}
const UserAvatar = (props: IUserAvatarProps) => {
    const character = useMemo(() => {
        if (props.fullName) {
            const texts = props.fullName.trim().split(' ');
            return texts[texts.length - 1].split('')[0];
        }
        return "nochar";
    }, [props.fullName])
    const width = useMemo(() => {
        if (props.size === "small") {
            return "16px";
        }
        if (props.size === "large") {
            return "32px";
        }
        if (props.size === "xlarge") {
            return "40px";
        }
        if (props.size === "xxlarge") {
            return "50px";
        }
        if (props.size === "xxxlarge") {
            return "64px";
        }
        return "24px";
    }, [props.size])
    // console.log({
    //     character,
    //     url: props.url
    // });

    return (
        <Box>
            {props.url && props.url != 'null' && props.url != "" && props.borderRadius === "" &&
                <Box sx={{
                    background: `url("${props.url}")`,
                    width,
                    height: width,
                    borderRadius: "50%",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                }}>

                </Box>
                // <img alt='avatar' src={`${props.url}`}
                //     width={width}
                //     height={width}
                //     style={{
                //         borderRadius: "50%",

                //     }}
                // />
            }
            {props.url && props.url != 'null' && props.url != "" && props.borderRadius != "" &&
                <Box sx={{
                    background: `url("${props.url}")`,
                    width,
                    height: width,
                    borderRadius: props.borderRadius,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                }}>
                </Box>
            }
            {(!props.url || props.url === "" || props.url === 'null') &&
                <img alt='avatar' src={`../../../../images/${character}.png`}
                    width={width}
                    height={width}
                    style={{
                        borderRadius: "50%",

                    }}
                />


            }
        </Box>
    );
};

export default UserAvatar;